"use strict";
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 127
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/implementation/web)
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ampli = exports.Ampli = exports.VerseLoungeVoteClicked = exports.VerseLoungeVisited = exports.VerseClickerCtaTapped = exports.VerseClickerBurn = exports.VerseBurnEngineResult = exports.VerseBurnEngineCtaTapped = exports.Tap = exports.SwapEntered = exports.SellCtaClicked = exports.RpcCtaClicked = exports.RpcAdded = exports.QuoteReceived = exports.PoolsVisited = exports.PoolVisited = exports.OrderStarted = exports.OrderCompleted = exports.NavigationClicked = exports.Navigate = exports.MultichainSwapStarted = exports.MultichainSwapResult = exports.LpDepositSuccessCta = exports.LpDepositSequenceStarted = exports.LpDepositSequenceEnded = exports.EarnVerseStakingWithdrawResult = exports.EarnVerseStakingOnboarding = exports.EarnVerseStakingDepositResult = exports.EarnVerseStakingCtaTapped = exports.EarnVerseStakingClaimResult = exports.Download = exports.ConnectWalletResult = exports.ConnectWalletOptionSelected = exports.ConnectWalletClicked = exports.BuyButtonClicked = exports.Identify = exports.DefaultConfiguration = exports.ApiKey = void 0;
const amplitude = __importStar(require("@amplitude/analytics-browser"));
exports.ApiKey = {
    production: '498ce6d5e47c1f87c8c0d2bd1078c4d1',
    development: 'fa7b1cc04ab3b1dd731237ca07c2ab94'
};
/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
exports.DefaultConfiguration = {
    plan: {
        version: '127',
        branch: 'main',
        source: 'web',
        versionId: '7d671c3a-25dc-4065-9755-37b8b79669d7'
    },
    ...{
        ingestionMetadata: {
            sourceName: 'browser-typescript-ampli',
            sourceVersion: '2.0.0'
        }
    }
};
class Identify {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = amplitude.Types.SpecialEventType.IDENTIFY;
        this.event_properties = event_properties;
    }
}
exports.Identify = Identify;
class BuyButtonClicked {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'buy_button_clicked';
        this.event_properties = event_properties;
    }
}
exports.BuyButtonClicked = BuyButtonClicked;
class ConnectWalletClicked {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'connect wallet clicked';
        this.event_properties = event_properties;
    }
}
exports.ConnectWalletClicked = ConnectWalletClicked;
class ConnectWalletOptionSelected {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'connect wallet option selected';
        this.event_properties = event_properties;
    }
}
exports.ConnectWalletOptionSelected = ConnectWalletOptionSelected;
class ConnectWalletResult {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'connect wallet result';
        this.event_properties = event_properties;
    }
}
exports.ConnectWalletResult = ConnectWalletResult;
class Download {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'download';
        this.event_properties = event_properties;
    }
}
exports.Download = Download;
class EarnVerseStakingClaimResult {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'earn verse staking claim result';
        this.event_properties = event_properties;
    }
}
exports.EarnVerseStakingClaimResult = EarnVerseStakingClaimResult;
class EarnVerseStakingCtaTapped {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'earn verse staking cta tapped';
        this.event_properties = event_properties;
    }
}
exports.EarnVerseStakingCtaTapped = EarnVerseStakingCtaTapped;
class EarnVerseStakingDepositResult {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'earn verse staking deposit result';
        this.event_properties = event_properties;
    }
}
exports.EarnVerseStakingDepositResult = EarnVerseStakingDepositResult;
class EarnVerseStakingOnboarding {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'earn verse staking onboarding';
        this.event_properties = event_properties;
    }
}
exports.EarnVerseStakingOnboarding = EarnVerseStakingOnboarding;
class EarnVerseStakingWithdrawResult {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'earn verse staking withdraw result';
        this.event_properties = event_properties;
    }
}
exports.EarnVerseStakingWithdrawResult = EarnVerseStakingWithdrawResult;
class LpDepositSequenceEnded {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'lp deposit sequence ended';
        this.event_properties = event_properties;
    }
}
exports.LpDepositSequenceEnded = LpDepositSequenceEnded;
class LpDepositSequenceStarted {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'lp deposit sequence started';
        this.event_properties = event_properties;
    }
}
exports.LpDepositSequenceStarted = LpDepositSequenceStarted;
class LpDepositSuccessCta {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'lp deposit success cta';
        this.event_properties = event_properties;
    }
}
exports.LpDepositSuccessCta = LpDepositSuccessCta;
class MultichainSwapResult {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'multichain swap result';
        this.event_properties = event_properties;
    }
}
exports.MultichainSwapResult = MultichainSwapResult;
class MultichainSwapStarted {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'multichain swap started';
        this.event_properties = event_properties;
    }
}
exports.MultichainSwapStarted = MultichainSwapStarted;
class Navigate {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'navigate';
        this.event_properties = event_properties;
    }
}
exports.Navigate = Navigate;
class NavigationClicked {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'navigation clicked';
        this.event_properties = event_properties;
    }
}
exports.NavigationClicked = NavigationClicked;
class OrderCompleted {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'order completed';
        this.event_properties = event_properties;
    }
}
exports.OrderCompleted = OrderCompleted;
class OrderStarted {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'order started';
        this.event_properties = event_properties;
    }
}
exports.OrderStarted = OrderStarted;
class PoolVisited {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'pool visited';
        this.event_properties = event_properties;
    }
}
exports.PoolVisited = PoolVisited;
class PoolsVisited {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'pools visited';
        this.event_properties = event_properties;
    }
}
exports.PoolsVisited = PoolsVisited;
class QuoteReceived {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'quote received';
        this.event_properties = event_properties;
    }
}
exports.QuoteReceived = QuoteReceived;
class RpcAdded {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'rpc added';
        this.event_properties = event_properties;
    }
}
exports.RpcAdded = RpcAdded;
class RpcCtaClicked {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'rpc cta clicked';
        this.event_properties = event_properties;
    }
}
exports.RpcCtaClicked = RpcCtaClicked;
class SellCtaClicked {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'sell_cta_clicked';
        this.event_properties = event_properties;
    }
}
exports.SellCtaClicked = SellCtaClicked;
class SwapEntered {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'swap entered';
        this.event_properties = event_properties;
    }
}
exports.SwapEntered = SwapEntered;
class Tap {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'tap';
        this.event_properties = event_properties;
    }
}
exports.Tap = Tap;
class VerseBurnEngineCtaTapped {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'verse burn engine cta tapped';
        this.event_properties = event_properties;
    }
}
exports.VerseBurnEngineCtaTapped = VerseBurnEngineCtaTapped;
class VerseBurnEngineResult {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'verse burn engine result';
        this.event_properties = event_properties;
    }
}
exports.VerseBurnEngineResult = VerseBurnEngineResult;
class VerseClickerBurn {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'verse clicker burn';
        this.event_properties = event_properties;
    }
}
exports.VerseClickerBurn = VerseClickerBurn;
class VerseClickerCtaTapped {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'verse clicker cta tapped';
        this.event_properties = event_properties;
    }
}
exports.VerseClickerCtaTapped = VerseClickerCtaTapped;
class VerseLoungeVisited {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'verse lounge visited';
        this.event_properties = event_properties;
    }
}
exports.VerseLoungeVisited = VerseLoungeVisited;
class VerseLoungeVoteClicked {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'verse lounge vote clicked';
        this.event_properties = event_properties;
    }
}
exports.VerseLoungeVoteClicked = VerseLoungeVoteClicked;
const getVoidPromiseResult = () => ({ promise: Promise.resolve() });
// prettier-ignore
class Ampli {
    constructor() {
        this.disabled = false;
    }
    get client() {
        this.isInitializedAndEnabled();
        return this.amplitude;
    }
    get isLoaded() {
        return this.amplitude != null;
    }
    isInitializedAndEnabled() {
        if (!this.amplitude) {
            console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
            return false;
        }
        return !this.disabled;
    }
    /**
     * Initialize the Ampli SDK. Call once when your application starts.
     *
     * @param options Configuration options to initialize the Ampli SDK with.
     */
    load(options) {
        this.disabled = options.disabled ?? false;
        if (this.amplitude) {
            console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
            return getVoidPromiseResult();
        }
        let apiKey = null;
        if (options.client && 'apiKey' in options.client) {
            apiKey = options.client.apiKey;
        }
        else if ('environment' in options) {
            apiKey = exports.ApiKey[options.environment];
        }
        if (options.client && 'instance' in options.client) {
            this.amplitude = options.client.instance;
        }
        else if (apiKey) {
            this.amplitude = amplitude.createInstance();
            const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
            return this.amplitude.init(apiKey, undefined, { ...exports.DefaultConfiguration, ...configuration });
        }
        else {
            console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
        }
        return getVoidPromiseResult();
    }
    /**
     * Identify a user and set user properties.
     *
     * @param userId The user's id.
     * @param properties The user properties.
     * @param options Optional event options.
     */
    identify(userId, properties, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        if (userId) {
            options = { ...options, user_id: userId };
        }
        const amplitudeIdentify = new amplitude.Identify();
        const eventProperties = properties;
        if (eventProperties != null) {
            for (const [key, value] of Object.entries(eventProperties)) {
                amplitudeIdentify.set(key, value);
            }
        }
        return this.amplitude.identify(amplitudeIdentify, options);
    }
    /**
     * Flush the event.
     */
    flush() {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.flush();
    }
    /**
     * Track event
     *
     * @param event The event to track.
     * @param options Optional event options.
     */
    track(event, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.track(event, undefined, options);
    }
    /**
     * buy_button_clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/buy_button_clicked)
     *
     * Event Details:
     * *Event fires when a user taps on a buy button in the app
     *
     * Property Details:
     * *entrypoint and screen will identify which buy button is being tapped
     *
     * Owner: Andrei Terentiev
     *
     * @param properties The event's properties (e.g. coin)
     * @param options Amplitude event options.
     */
    buyButtonClicked(properties, options) {
        return this.track(new BuyButtonClicked(properties), options);
    }
    /**
     * connect wallet clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/connect%20wallet%20clicked)
     *
     * This event tracks when a user clicks on the "Connect Wallet" button on the Verse DEX. It indicates user interest in connecting their wallet.
     *
     *   Fired: on click
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    connectWalletClicked(properties, options) {
        return this.track(new ConnectWalletClicked(properties), options);
    }
    /**
     * connect wallet option selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/connect%20wallet%20option%20selected)
     *
     * This event tracks when a user selects a connection method to connect their wallet to the Verse DEX. It indicates the user's interest in using the particular conenction method.
     *
     *  Fired: on click
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    connectWalletOptionSelected(properties, options) {
        return this.track(new ConnectWalletOptionSelected(properties), options);
    }
    /**
     * connect wallet result
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/connect%20wallet%20result)
     *
     * Records the result of a wallet connection attempt.
     *
     *
     *  If successful:
     *
     *  * success = true
     *
     *  If not successful:
     *
     *  * success = false
     *
     *  * error = provide the error message from the wallet connect provider (eg. wallet connect, metamask)
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    connectWalletResult(properties, options) {
        return this.track(new ConnectWalletResult(properties), options);
    }
    /**
     * download
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/download)
     *
     * Tracks when a user downloads the Verse Whitepaper through the mobile rewards page at https://verse.bitcoin.com/rewards/
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. platform)
     * @param options Amplitude event options.
     */
    download(properties, options) {
        return this.track(new Download(properties), options);
    }
    /**
     * earn verse staking claim result
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/earn%20verse%20staking%20claim%20result)
     *
     * User completes a claim flow in Verse Staking in Earn. Fired on: success or failure.
     *  https://miro.com/app/board/uXjVMz91EHI=/
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. deposit wallet address)
     * @param options Amplitude event options.
     */
    earnVerseStakingClaimResult(properties, options) {
        return this.track(new EarnVerseStakingClaimResult(properties), options);
    }
    /**
     * earn verse staking cta tapped
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/earn%20verse%20staking%20cta%20tapped)
     *
     * The user taps on a CTA with the Verse Staking flow in app. Fired on: tap.
     *  https://miro.com/app/board/uXjVMz91EHI=/
     *
     *  CTAs tracked (options): buy, swap, learn more
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. cta)
     * @param options Amplitude event options.
     */
    earnVerseStakingCtaTapped(properties, options) {
        return this.track(new EarnVerseStakingCtaTapped(properties), options);
    }
    /**
     * earn verse staking deposit result
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/earn%20verse%20staking%20deposit%20result)
     *
     * User reaches the end of the verse staking deposit flow in Earn. Fired on: success or failure.
     *  https://miro.com/app/board/uXjVMz91EHI=/
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. deposit wallet address)
     * @param options Amplitude event options.
     */
    earnVerseStakingDepositResult(properties, options) {
        return this.track(new EarnVerseStakingDepositResult(properties), options);
    }
    /**
     * earn verse staking onboarding
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/earn%20verse%20staking%20onboarding)
     *
     * User sees onboarding screen for verse staking in Earn, and proceeds to deposit. Fired on: user taps deposit with zero VERSE in wallet https://miro.com/app/board/uXjVMz91EHI=/
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. deposit wallet address)
     * @param options Amplitude event options.
     */
    earnVerseStakingOnboarding(properties, options) {
        return this.track(new EarnVerseStakingOnboarding(properties), options);
    }
    /**
     * earn verse staking withdraw result
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/earn%20verse%20staking%20withdraw%20result)
     *
     * User completes a withdraw flow in Verse Staking in Earn. Fired on: success or failure.
     *  https://miro.com/app/board/uXjVMz91EHI=/
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. deposit wallet address)
     * @param options Amplitude event options.
     */
    earnVerseStakingWithdrawResult(properties, options) {
        return this.track(new EarnVerseStakingWithdrawResult(properties), options);
    }
    /**
     * lp deposit sequence ended
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/lp%20deposit%20sequence%20ended)
     *
     * The user reaches the end of a deposit sequence on the Verse DEX and is presented with a result.
     *
     *  Fired on:
     *
     *  * Transaction status screen updated with a "Failed" state
     *
     *   * lp deposit result = "failed"
     *
     *   * reason = one of:
     *
     *   * "deposit not confirmed"
     *
     *   * "token not approved"
     *
     *   * "generic error"
     *
     *  * Transaction status screen updated with a "Success" state
     *
     *   * lp deposit result = "success"
     *
     *   * reason = "'
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    lpDepositSequenceEnded(properties, options) {
        return this.track(new LpDepositSequenceEnded(properties), options);
    }
    /**
     * lp deposit sequence started
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/lp%20deposit%20sequence%20started)
     *
     * A user initiates an LP deposit on the Verse DEX.
     *
     *  Fired on "Confirm Deposit" CTA clicked.
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. asset a count)
     * @param options Amplitude event options.
     */
    lpDepositSequenceStarted(properties, options) {
        return this.track(new LpDepositSequenceStarted(properties), options);
    }
    /**
     * lp deposit success cta
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/lp%20deposit%20success%20cta)
     *
     * A user clicks a CTA at the end of the lp deposit sequence on the Verse DEX.
     *
     *  Possible actions:
     *
     *  * "add token to metamask"
     *
     *  * "view transaction"
     *
     *  Fired on CTA click.
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. action)
     * @param options Amplitude event options.
     */
    lpDepositSuccessCta(properties, options) {
        return this.track(new LpDepositSuccessCta(properties), options);
    }
    /**
     * multichain swap result
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/multichain%20swap%20result)
     *
     * This event tracks the result of multichain swaps on the Verse DEX.
     *
     *
     * Fired on: result received from swap provider
     *
     *
     * If swap is successful:
     *
     * * success = true
     *
     * If swap is not successful:
     *
     * * success = false
     *
     * * error reason = provide the error from the swap provider
     *
     * * refunded = true, false
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. error)
     * @param options Amplitude event options.
     */
    multichainSwapResult(properties, options) {
        return this.track(new MultichainSwapResult(properties), options);
    }
    /**
     * multichain swap started
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/multichain%20swap%20started)
     *
     * This event is triggered when a multichain swap is initiated.
     *
     *  The user has:
     *  1. connected their web3 wallet
     *  2. selected to and from tokens
     *  3. provided the input amounts
     *
     *  Fired on: "Swap" CTA clicked
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. from)
     * @param options Amplitude event options.
     */
    multichainSwapStarted(properties, options) {
        return this.track(new MultichainSwapStarted(properties), options);
    }
    /**
     * navigate
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/navigate)
     *
     * Tracks when a user navigates to one of our social media profiles through the Verse rewards page
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. platform)
     * @param options Amplitude event options.
     */
    navigate(properties, options) {
        return this.track(new Navigate(properties), options);
    }
    /**
     * navigation clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/navigation%20clicked)
     *
     * This event tracks when a user clicks on a navigation element on the Verse DEX.
     *
     *  eg. Header, Footer, left nav (desktop), or bottom nav (mobile)
     *
     *
     *  Fired on: click
     *
     *
     *  note:
     *
     *  For users entering via the Earn feature:
     *
     *  1\. The Earn feature will pass "session id" as a webview param
     *
     *  2\. The "session id" will be included in subsequent events
     *
     *  Note: Pathfinder charts will not display correctly
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    navigationClicked(properties, options) {
        return this.track(new NavigationClicked(properties), options);
    }
    /**
     * order completed
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/order%20completed)
     *
     * This event tracks when a user successfully completes a swap transaction on the dex
     *
     * Owner: Allison Le
     *
     * @param properties The event's properties (e.g. from)
     * @param options Amplitude event options.
     */
    orderCompleted(properties, options) {
        return this.track(new OrderCompleted(properties), options);
    }
    /**
     * order started
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/order%20started)
     *
     * triggers when a user slides to swap in the Preview screen or complets the swap from their end
     *
     * Owner: Andrei Terentiev
     *
     * @param properties The event's properties (e.g. from)
     * @param options Amplitude event options.
     */
    orderStarted(properties, options) {
        return this.track(new OrderStarted(properties), options);
    }
    /**
     * pool visited
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/pool%20visited)
     *
     * A user visits a particular pool details page on the DEX.
     *
     *  eg. /pools/eth/eth-verse/deposit/
     *
     *  This event will be fired:
     *
     *  1. When a user with deposits accesses https://verse.bitcoin.com/pools/eth/verse-eth/deposit/ through the ‚ÄòDeposit More‚Äô button on the pool details transition page
     *
     *  2. When a user without deposits accesses https://verse.bitcoin.com/pools/eth/verse-eth/deposit/ through the ‚ÄòDeposit‚Äô button on the main pool page
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    poolVisited(properties, options) {
        return this.track(new PoolVisited(properties), options);
    }
    /**
     * pools visited
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/pools%20visited)
     *
     * A user visits the main pools page (eg. /pools/eth/) and views a list of pools on the DEX.
     *
     *
     *   If the user is NOT coming from a CTA, send entrypoint = "".
     *
     *
     *  Fired on page load.
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    poolsVisited(properties, options) {
        return this.track(new PoolsVisited(properties), options);
    }
    /**
     * quote received
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/quote%20received)
     *
     * tracks all the events when user clicks on 'Get Quote' CTA on the swap main screen
     *
     * Owner: Andrei Terentiev
     *
     * @param properties The event's properties (e.g. client min crypto)
     * @param options Amplitude event options.
     */
    quoteReceived(properties, options) {
        return this.track(new QuoteReceived(properties), options);
    }
    /**
     * rpc added
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/rpc%20added)
     *
     * User successfully changes their RPC network to the Blinklabs endpoint
     *
     * Owner: Allison Le
     *
     * @param properties The event's properties (e.g. pageview)
     * @param options Amplitude event options.
     */
    rpcAdded(properties, options) {
        return this.track(new RpcAdded(properties), options);
    }
    /**
     * rpc cta clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/rpc%20cta%20clicked)
     *
     * User interacts with something on the Blinklabs RPC modal after connecting their Metamask wallet
     *
     * Owner: Allison Le
     *
     * @param properties The event's properties (e.g. pageview)
     * @param options Amplitude event options.
     */
    rpcCtaClicked(properties, options) {
        return this.track(new RpcCtaClicked(properties), options);
    }
    /**
     * sell_cta_clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/sell_cta_clicked)
     *
     * User presses "Sell" button on main screen/page
     *
     * Owner: Andrei Terentiev
     *
     * @param properties The event's properties (e.g. pageview)
     * @param options Amplitude event options.
     */
    sellCtaClicked(properties, options) {
        return this.track(new SellCtaClicked(properties), options);
    }
    /**
     * swap entered
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/swap%20entered)
     *
     * User loads swap interface
     *
     * Owner: Andrei Terentiev
     *
     * @param properties The event's properties (e.g. entrypoint)
     * @param options Amplitude event options.
     */
    swapEntered(properties, options) {
        return this.track(new SwapEntered(properties), options);
    }
    /**
     * tap
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/tap)
     *
     * This event tracks when a user taps on an element within the mobile rewards portal at https://verse.bitcoin.com/rewards/
     *
     *  or the revised verse home page at https://verse.bitcoin.com/
     *
     *  * Refer to the Amplitude implementation plan for the respective event properties to send for each page.
     *
     *  * for Revised Verse Home Page, send:
     *
     *   * current page
     *
     *   * session id
     *
     *   * to
     *
     *   * screen size
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. current page)
     * @param options Amplitude event options.
     */
    tap(properties, options) {
        return this.track(new Tap(properties), options);
    }
    /**
     * verse burn engine cta tapped
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/verse%20burn%20engine%20cta%20tapped)
     *
     * This event tracks when a user taps on a CTA in the Verse Burn Engine.
     *
     *  CTAs tracked = learn, statistics
     *
     *   Fired on tap
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. cta)
     * @param options Amplitude event options.
     */
    verseBurnEngineCtaTapped(properties, options) {
        return this.track(new VerseBurnEngineCtaTapped(properties), options);
    }
    /**
     * verse burn engine result
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/verse%20burn%20engine%20result)
     *
     * This event tracks successful contributions and burns from the Verse Burn Engine.
     *   CTAs = burn, contribute
     *   Fired on tx success
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    verseBurnEngineResult(properties, options) {
        return this.track(new VerseBurnEngineResult(properties), options);
    }
    /**
     * verse clicker burn
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/verse%20clicker%20burn)
     *
     * This event tracks when a user successfully burns VERSE via the Verse Clicker.
     *
     *  Fired on successful transaction confirmation of the burn
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. blockchain)
     * @param options Amplitude event options.
     */
    verseClickerBurn(properties, options) {
        return this.track(new VerseClickerBurn(properties), options);
    }
    /**
     * verse clicker cta tapped
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/verse%20clicker%20cta%20tapped)
     *
     * This event tracks when a user taps on the call-to-action button in the Verse Clicker dapp
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. cta)
     * @param options Amplitude event options.
     */
    verseClickerCtaTapped(properties, options) {
        return this.track(new VerseClickerCtaTapped(properties), options);
    }
    /**
     * verse lounge visited
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/verse%20lounge%20visited)
     *
     * This event tracks when a user visits the Verse Lounge on verse.bitcoin.com/lounge
     *
     *
     *  Fired on: page load
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. screen size)
     * @param options Amplitude event options.
     */
    verseLoungeVisited(properties, options) {
        return this.track(new VerseLoungeVisited(properties), options);
    }
    /**
     * verse lounge vote clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/bitcoincom/Bitcoin.com%20Wallet/events/main/latest/verse%20lounge%20vote%20clicked)
     *
     * This event tracks when a user clicks on the "Vote" button in the Verse Lounge voting section
     *
     *   Fired on: Click
     *
     * Owner: Joel Tan
     *
     * @param properties The event's properties (e.g. current page)
     * @param options Amplitude event options.
     */
    verseLoungeVoteClicked(properties, options) {
        return this.track(new VerseLoungeVoteClicked(properties), options);
    }
}
exports.Ampli = Ampli;
exports.ampli = new Ampli();
//# sourceMappingURL=index.js.map